<template>
  <transition name="modal-fade">
    <div v-if="isVisible" class="modal-overlay">
      <div class="modal-container">
        <button class="modal-close" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>

        <div class="modal-header">
          <div class="form-tabs">
            <button
              class="tab-button"
              :class="{ active: activeTab === 'contact' }"
              @click="activeTab = 'contact'"
            >
              聯絡表單
            </button>
            <button
              class="tab-button"
              :class="{ active: activeTab === 'edit' }"
              @click="activeTab = 'edit'"
            >
              編輯聯絡資訊
            </button>
          </div>
          <h2 class="modal-title">
            {{ activeTab === "contact" ? "聯絡我們" : "編輯聯絡資訊" }}
          </h2>
          <p class="modal-subtitle">
            {{
              activeTab === "contact"
                ? "請填寫以下資訊,我們會盡快回覆您"
                : "更新公司地址和聯絡電話"
            }}
          </p>
        </div>

        <!-- 聯絡表單 -->
        <form
          v-if="activeTab === 'contact'"
          @submit.prevent="handleSubmit"
          class="contact-form"
        >
          <!-- 第一行: 公司名稱 + 稱呼 -->
          <div class="form-row">
            <div class="form-group">
              <label for="company" class="form-label">
                公司名稱 <span class="required">*</span>
              </label>
              <input
                type="text"
                id="company"
                v-model="formData.company"
                class="form-input"
                placeholder="您的公司名稱"
                required
              />
            </div>

            <div class="form-group">
              <label class="form-label">
                您的姓名 <span class="required">*</span>
              </label>
              <div class="gender-name-group">
                <input
                  type="text"
                  v-model="formData.name"
                  class="form-input name-input"
                  placeholder="您的名字"
                  required
                />
                <div class="gender-options">
                  <label class="radio-label">
                    <input
                      type="radio"
                      v-model="formData.gender"
                      value="小姐"
                      required
                    />
                    <span>小姐</span>
                  </label>
                  <label class="radio-label">
                    <input
                      type="radio"
                      v-model="formData.gender"
                      value="先生"
                      required
                    />
                    <span>先生</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- 第二行: Email + 電話 -->
          <div class="form-row">
            <div class="form-group">
              <label for="email" class="form-label">
                電子信箱 <span class="required">*</span>
              </label>
              <input
                type="email"
                id="email"
                v-model="formData.email"
                class="form-input"
                placeholder="example@email.com"
                required
              />
            </div>

            <div class="form-group">
              <label for="phone" class="form-label">
                連絡電話 <span class="required">*</span>
              </label>
              <input
                type="tel"
                id="phone"
                v-model="formData.phone"
                class="form-input"
                placeholder="0912345678"
                required
              />
            </div>
          </div>

          <!-- 第三行: 諮詢項目 + 期望時段 -->
          <div class="form-row">
            <div class="form-group">
              <label for="service" class="form-label">
                諮詢項目 <span class="required">*</span>
              </label>
              <select
                id="service"
                v-model="formData.service"
                class="form-select"
                required
              >
                <option value="" disabled>選擇您感興趣的服務</option>
                <option value="醫療器材">醫療器材</option>
                <option value="設備維護">設備維護</option>
                <option value="技術支援">技術支援</option>
                <option value="產品諮詢">產品諮詢</option>
                <option value="其他">其他</option>
              </select>
            </div>

            <div class="form-group">
              <label for="time" class="form-label">
                希望聯繫時段 <span class="required">*</span>
              </label>
              <select
                id="time"
                v-model="formData.time"
                class="form-select"
                required
              >
                <option value="" disabled>您希望的聯繫時間</option>
                <option value="上午 (09:00-12:00)">上午 (09:00-12:00)</option>
                <option value="下午 (13:00-17:00)">下午 (13:00-17:00)</option>
                <option value="晚上 (18:00-21:00)">晚上 (18:00-21:00)</option>
                <option value="不指定">不指定</option>
              </select>
            </div>
          </div>

          <!-- 詳細需求 -->
          <div class="form-group">
            <label for="message" class="form-label"> 您的詳細需求 </label>
            <textarea
              id="message"
              v-model="formData.message"
              class="form-textarea"
              rows="5"
              placeholder="請分享您的需求或問題"
            ></textarea>
          </div>

          <!-- 送出按鈕 -->
          <div class="form-actions">
            <button
              type="submit"
              class="btn-submit-full"
              :disabled="isSubmitting"
            >
              {{ isSubmitting ? "送出中..." : "送出您的需求" }}
            </button>
          </div>

          <p class="form-note">感謝您的分享,我們將由專人與您聯繫</p>
        </form>

        <!-- 編輯聯絡資訊表單 -->
        <form
          v-if="activeTab === 'edit'"
          @submit.prevent="handleUpdateContactInfo"
          class="contact-form"
        >
          <div class="form-group">
            <label for="edit-address" class="form-label">
              公司地址 <span class="required">*</span>
            </label>
            <input
              type="text"
              id="edit-address"
              v-model="editContactData.address"
              class="form-input"
              placeholder="請輸入公司地址"
              required
            />
          </div>

          <div class="form-group">
            <label for="edit-phone" class="form-label">
              聯絡電話 <span class="required">*</span>
            </label>
            <input
              type="text"
              id="edit-phone"
              v-model="editContactData.phone"
              class="form-input"
              placeholder="請輸入聯絡電話"
              required
            />
          </div>

          <div class="form-actions">
            <button
              type="submit"
              class="btn-submit-full"
              :disabled="isSubmitting"
            >
              {{ isSubmitting ? "更新中..." : "更新聯絡資訊" }}
            </button>
          </div>

          <p class="form-note">更新後將立即生效</p>
        </form>
      </div>
    </div>
  </transition>
</template>

<script>
import api from "@/assets/js/utils/api.js";
import {
  showSuccess,
  showCustom,
  showLoading,
  hideLoading,
} from "@/assets/js/utils/alertService";
export default {
  name: "ContactForm",
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      activeTab: "contact", // 控制當前標籤頁
      formData: {
        company: "",
        gender: "",
        name: "",
        email: "",
        phone: "",
        service: "",
        time: "",
        budget: "",
        message: "",
      },
      editContactData: {
        address: "",
        phone: "",
      },
      isSubmitting: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    async handleSubmit() {
      this.isSubmitting = true;

      try {
        // 🔵 顯示寄送中 Loading
        showLoading("寄送中，請稍候...");

        // ⭐ 組後端要的 JSON 格式（大寫）
        const payload = {
          CompanyName: this.formData.company,
          FullName: this.formData.name + (this.formData.gender ?? ""),
          Email: this.formData.email,
          Phone: this.formData.phone,
          ConsultItem: this.formData.service,
          ContactTime: this.formData.time || null,
          Message: this.formData.message || "",
        };

        // 🔵 呼叫後端 API
        const response = await api.post("/ContactFunction", payload);
        const result = response.data;

        // 🔵 關閉 Loading
        hideLoading();

        if (!result.success) {
          showCustom({
            icon: "error",
            title: "送出失敗",
            text: result.message ?? "伺服器回傳異常",
          });
          this.isSubmitting = false;
          return;
        }

        // 🔵 成功提示
        showSuccess("您的需求已成功送出，我們會盡快與您聯繫！");

        // ⭐ 清空表單 & 關閉 Modal
        this.resetForm();
        this.closeModal();
      } catch (error) {
        console.error("送出失敗:", error);

        // 🔵 發生錯誤也要關閉 Loading
        hideLoading();

        showCustom({
          icon: "error",
          title: "伺服器錯誤",
          text: "表單送出失敗，請稍後再試。",
        });
      }

      this.isSubmitting = false;
    },
    async handleUpdateContactInfo() {
      this.isSubmitting = true;

      try {
        showLoading("更新中，請稍候...");

        // 呼叫後端 API 更新聯絡資訊
        const payload = {
          address: this.editContactData.address,
          phone: this.editContactData.phone,
        };

        const response = await api.post("/dashboard/contact", payload);
        const result = response.data;

        hideLoading();

        if (!result.success) {
          showCustom({
            icon: "error",
            title: "更新失敗",
            text: result.message ?? "伺服器回傳異常",
          });
          this.isSubmitting = false;
          return;
        }

        showSuccess("聯絡資訊已成功更新！");
        this.closeModal();
        // 觸發父元件的 refresh 事件
        this.$emit("contact-info-updated");
      } catch (error) {
        console.error("更新失敗:", error);
        hideLoading();

        showCustom({
          icon: "error",
          title: "伺服器錯誤",
          text: "更新失敗，請稍後再試。",
        });
      }

      this.isSubmitting = false;
    },
    resetForm() {
      this.formData = {
        company: "",
        gender: "",
        name: "",
        email: "",
        phone: "",
        service: "",
        time: "",
        budget: "",
        message: "",
      };
    },
  },
  watch: {
    isVisible(newVal) {
      // 當 modal 開啟時鎖定背景滾動
      if (newVal) {
        document.body.style.overflow = "hidden";
        this.activeTab = "contact"; // 重置為聯絡表單標籤
      } else {
        document.body.style.overflow = "auto";
      }
    },
  },
  beforeUnmount() {
    document.body.style.overflow = "auto";
  },
};
</script>

<style scoped>
/* ==========================================
   Mobile First 設計 - 基礎樣式 (手機版)
   ========================================== */

/* 模態框遮罩 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  overflow-y: auto;
}

/* 模態框容器 */
.modal-container {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease-out;
}

/* 關閉按鈕 */
.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

/* 表單標籤頁 */
.form-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  border-bottom: 2px solid #e2e8f0;
}

.tab-button {
  padding: 10px 15px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #718096;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
}

.tab-button.active {
  color: #3b3b7e;
  border-bottom-color: #3b3b7e;
}

.tab-button:hover:not(.active) {
  color: #4a5568;
}

/* 模態框標題區 */
.modal-header {
  padding: 25px 20px 20px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  margin-top: -1rem;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #3b3b7e;
  margin: 0 0 8px 0;
}

.modal-subtitle {
  font-size: 14px;
  color: #718096;
  margin: 0;
  margin-bottom: -1rem;
}

/* 表單樣式 */
.contact-form {
  padding: 25px 20px;
  margin-top: -2rem;
}

/* 表單行 (兩欄並排) */
.form-row {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 0;
  flex: 1;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 8px;
}

.form-label i {
  color: #fda828;
  font-size: 14px;
  margin-right: 6px;
}

.required {
  color: #e74c3c;
  font-weight: 700;
}

/* 性別+姓名組合 */
.gender-name-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.gender-options {
  display: flex;
  gap: 20px;
}

.radio-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 14px;
  color: #2d3748;
}

.radio-label input[type="radio"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #3b3b7e;
}

.radio-label span {
  user-select: none;
}

.name-input {
  flex: 1;
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 12px 15px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 18px;
  font-family: inherit;
  color: #2d3748;
  transition: all 0.3s ease;
  background: #f7fafc;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: #3b3b7e;
  background: white;
  box-shadow: 0 0 0 3px rgba(59, 59, 126, 0.1);
}

.form-textarea {
  resize: vertical;
  min-height: 100px;
  line-height: 1.6;
}

/* 表單按鈕區 */
.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 25px;
  margin-bottom: 15px;
}

.btn-submit-full {
  width: 100%;
  padding: 14px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #3b3b7e;
  color: white;
}

.btn-submit-full:hover:not(:disabled) {
  background: #7a6139;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(147, 119, 74, 0.3);
}

.btn-submit-full:disabled {
  background: #cbd5e0;
  cursor: not-allowed;
  transform: none;
}

/* 表單提示文字 */
.form-note {
  text-align: center;
  font-size: 13px;
  color: #718096;
  margin: 0;
}

/* 動畫 */
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Modal 淡入淡出動畫 */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

/* ==========================================
   平板版 (min-width: 768px)
   ========================================== */
@media (min-width: 768px) {
  .modal-container {
    max-width: 700px;
  }

  .modal-header {
    padding: 30px 30px 25px;
  }

  .modal-title {
    font-size: 28px;
  }

  .modal-subtitle {
    font-size: 15px;
  }

  .contact-form {
    padding: 30px;
  }

  /* 兩欄並排 */
  .form-row {
    flex-direction: row;
    gap: 20px;
  }

  .gender-name-group {
    flex-direction: row;
    align-items: center;
  }

  .gender-options {
    min-width: 150px;
  }

  .form-label {
    font-size: 15px;
    margin-bottom: 10px;
  }

  .form-input,
  .form-select,
  .form-textarea {
    padding: 14px 16px;
    font-size: 15px;
  }

  .form-textarea {
    min-height: 120px;
  }

  .btn-submit-full {
    padding: 15px 24px;
    font-size: 17px;
  }

  .form-note {
    font-size: 14px;
  }
}

/* ==========================================
   電腦版 (min-width: 1024px)
   ========================================== */
@media (min-width: 1024px) {
  .modal-container {
    max-width: 800px;
  }

  .modal-close {
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;
    font-size: 26px;
  }

  .modal-header {
    padding: 40px 40px 30px;
  }

  .modal-title {
    font-size: 32px;
  }

  .modal-subtitle {
    font-size: 16px;
  }

  .contact-form {
    padding: 40px;
  }

  .form-row {
    gap: 25px;
  }

  .form-input,
  .form-select,
  .form-textarea {
    padding: 15px 18px;
    font-size: 16px;
  }

  .form-textarea {
    min-height: 140px;
  }

  .form-actions {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .btn-submit-full {
    padding: 16px 28px;
    font-size: 18px;
  }

  .form-note {
    font-size: 15px;
  }
}
</style>
